import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { lensProp, map, set } from "ramda";

const langs = [
  { value: "eng", id: "english", display: "English", translation: "" },
  { value: "arm", id: "armenian", display: "Armenian", translation: "" },
  { value: "chi", id: "chinese", display: "Chinese", translation: "" },
  { value: "fre", id: "french", display: "French", translation: "" },
  { value: "ger", id: "german", display: "German", translation: "" },
  { value: "kor", id: "korean", display: "Korean", translation: "" },
  { value: "spa", id: "spanish", display: "Spanish", translation: "" },
  { value: "ara", id: "arabic", display: "Arabic", translation: "" },
];

// Add new languages to translation files
export const useLanguages = () => {
  const { t } = useTranslation();
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    const languages = map(
      (lang) =>
        set(
          lensProp("translation"),
          t(`file_details.languages.${lang.id}`, lang.display),
          lang
        ),
      langs
    );
    setLanguages(languages);
  }, [t]);

  return languages;
};
